export default "__VITE_ASSET__Dii4RPaq__"